import { Description, Label } from "components"; // Importing Description and Label components

import "./label-description.scss"; // Importing SCSS styles for the LabelDescription component

interface ILabelDescription {
  label?: string | JSX.Element; // The label text or element to be displayed
  description?: string | JSX.Element; // The description text or element to be displayed
  labelClass?: string; // The labelClass to style your label
  sublabelClass?: string; // The sublabelClass to style your label
}

/**
 * LabelDescription component displays a label and a description.
 *
 * @param {ILabelDescription} props - The properties object for the LabelDescription component.
 * @param {string | JSX.Element} [props.label] - The label to be displayed.
 * @param {string | JSX.Element} [props.description] - The description to be displayed.
 * @param {string} [props.labelClass] - The labelClass foe style your label.
 * @param {string} [props.sublabelClass] - The sublabelClass foe style your sublabel.
 * @returns {JSX.Element} The rendered LabelDescription component.
 */
export const LabelDescription = ({
  label,
  description,
  labelClass = "",
  sublabelClass = "",
}: ILabelDescription) => {
  return (
    <div className="label-description-wrapper">
      {/* Render the label using the Label component */}
      <Label content={label} className={labelClass} />{" "}
      {/* Render the description using the Description component */}
      <Description content={description} className={sublabelClass} />{" "}
    </div>
  );
};
